/**
 * @file Community
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import classnames from 'classnames';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {fetchHelpapiGettext} from '../../actions/communityAction';

import './index.less';

export class Community extends Component {

    static propTypes = {
        fetchHelpapiGettext: PropTypes.func,
        helpapiGettext: PropTypes.object,
        match: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            index: 0,
            isFixed: false
        };

        this.changeTab = this.changeTab.bind(this);
        this.srcollTop = this.srcollTop.bind(this);
        this.renderTypicalCase = this.renderTypicalCase.bind(this);
    }

    componentWillMount() {
        if (this.isPC()) {
            let params = this.props.match.params;
            let url = '';
            if (params.fileType) {
                url = `id=${params.urlId}&file_type=${params.fileType}`;
            } else {
                url = `id=${params.urlId}`;
            }

            if (params.typeid) {
                url += `&typeid=${params.typeid}`;
            }

            location.href = `/help?${url}`;
        }
    }

    componentDidMount() {
        let params = this.props.match.params;
        this.props.fetchHelpapiGettext({
            urlId: params.urlId,
            fileType: params.fileType
        });

        window.addEventListener('scroll', this.srcollTop);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.srcollTop);
    }

    srcollTop() {
        if (this.tabNode) {
            const srcollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const tabNodeTop = this.tabNode.offsetTop;
            const tabNodeHeight = this.tabNode.offsetHeight;

            if (srcollTop > tabNodeTop - tabNodeHeight) {
                this.setState({isFixed: true});
            }
            else if (srcollTop <= tabNodeTop - tabNodeHeight) {
                this.setState({isFixed: false});
            }
        }
    }

    changeTab(index) {
        this.setState({index});

        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }

    renderTypicalCase({helpList}) {
        return (
            [<div key="tab" style={{height: '1.3rem'}} ref={tabNode => this.tabNode = tabNode}>
                <div className={classnames('tab-content', {tabFixed: this.state.isFixed})}>
                    <div className="tab-wrapper">
                        <div className="tab">
                            {helpList && helpList.map((helpItem, index) => (
                                <div
                                    onClick={this.changeTab.bind(this, index)}
                                    className={classnames('tab-item', {active: this.state.index === index})}
                                    key={index}>
                                    {helpItem.title}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>,
            <div key="content" className="community-text-contant">
                {helpList && helpList.map((helpItem, index) => (
                    <div
                        key={index}
                        className={classnames('community-text-item', {active: this.state.index === index})}>
                        {helpItem.note
                            && <div className="note">
                                {helpItem.note}
                            </div>}
                        {
                            helpItem.logo_pic
                            && <div className="logo-pic">
                                <img src={helpItem.logo_pic} alt="logo-pic" />
                            </div>
                        }
                        <div
                            className={classnames('community-text-item-content', {show: index === helpItem})}

                            dangerouslySetInnerHTML={{__html: helpItem.content}}>
                        </div>
                    </div>
                ))}
            </div>]
        );
    }

    render() {
        const helpapiGettext = this.props.helpapiGettext;
        let helpData = null;
        let helpList = [];
        let helpType = null;
        if (!this.isEmptyobj(helpapiGettext)) {
            helpData = helpapiGettext.itemlist.help_data;
            helpList = helpapiGettext.itemlist.help_list;
            helpType = helpData && helpData.help_type;
        }

        return (
            <div className={'community'}>
                <h1>
                    {
                        !this.isEmptyobj(helpapiGettext)
                            ? <span>
                                {helpData.page_name}&nbsp;|&nbsp;{helpData.help_title}
                            </span>
                            : ''
                    }
                </h1>
                {helpType === '3'
                    ? this.renderTypicalCase({helpData, helpList})
                    : (
                        <div className={'community-text'}>
                            {!this.isEmptyobj(helpapiGettext)
                                ? helpList.map((item, index) => {
                                    return <div className={'community-mod'} key={index}>
                                        {
                                            item.title && item.title.length
                                                ? <h3
                                                    className={
                                                        item.content && item.content.length
                                                            ? 'community-cut'
                                                            : ''}>
                                                    {
                                                        helpData.help_type === '1'
                                                            ? <div className={'class-hint'}>Q: </div>
                                                            : ''
                                                    }
                                                    <div className={'cell'}>
                                                        {item.title}
                                                    </div>
                                                </h3>
                                                : ''
                                        }
                                        {
                                            item.content && item.content.length
                                                ? <div className={'community-conten'}>
                                                    {
                                                        helpData.help_type === '1'
                                                            ? <div className={'class-hint'}>A: </div>
                                                            : ''
                                                    }
                                                    <div
                                                        className={'cell'}
                                                        dangerouslySetInnerHTML={{__html: item.content}}>
                                                    </div>
                                                </div>
                                                : ''
                                        }
                                    </div>;
                                })
                                : ''
                            }
                        </div>
                    )
                }
            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        helpapiGettext: state.helpapiGettext
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchHelpapiGettext: obj => fetchHelpapiGettext(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Community);



// WEBPACK FOOTER //
// ./src/containers/community/index.js